// eslint-disable-next-line no-useless-escape
export const phoneRegExp = /^(?:\+?[0-9]){6,15}$/;
